module.exports = __webpack_public_path__ + "media/images/julaimabg-dfd2e2cccf41410fff9b83d60bb1b826.jpg";